import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { IssueId } from '@atlassian/jira-shared-types/src/general.tsx';
import { JIRA_ISSUE_AUTO_LINK_CONTENT_ON_LINK_PASTE } from '../../common/constants/index.tsx';
import type { TrackEmbeddedConfluence } from '../../common/types/types.tsx';

type RemoteLink = {
	application: { name?: string };
	object: { url: string };
};

// urls of form "https://<SITE_NAME>/wiki/pages/viewpage.action?pageId=2555985"
export const getRemoteLinkIds = async (
	issueId: IssueId,
	fireAnalyticsEvent: TrackEmbeddedConfluence,
) => {
	const remoteLinks = await performGetRequest<RemoteLink[]>(
		`/rest/api/3/issue/${issueId}/remotelink`,
	);

	fireAnalyticsEvent({
		action: 'checked',
		actionSubject: 'remoteLinks',
		embeddedConfluenceSource: JIRA_ISSUE_AUTO_LINK_CONTENT_ON_LINK_PASTE,
		eventName: 'remoteLinks checked',
		eventType: 'track',
	});

	return remoteLinks
		.filter(({ application }) => application.name === 'System Confluence')
		.map(({ object }) => object.url.split('=').pop());
};
